import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {StateService} from "../../../services/StateService";
import {DateFormater} from "../../../services/DateFormatter.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {TpFirmTodoService} from "../../../tpiq-services/tp-firm-todo.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TasksService} from "../../../services/Tasks.service";
import {PageTitleService} from "../../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {NewPostComponent} from "../../../posts/new-post/new-post.component";
import {PostWallComponent} from "../../../posts/post-wall/post-wall.component"
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import {LinkyModule} from "ngx-linky";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";
import { environment } from '../../../../environments/environment';

declare const _: any;

@Component({
  selector: 'app-todo-single-page',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, NewPostComponent, FileUploadModule, FroalaEditorModule, FroalaViewModule, LinkyModule,
  TpiqCustomDatepicker, PostWallComponent],
  templateUrl: './todo-single-page.component.html',
  styleUrl: './todo-single-page.component.scss'
})
export class TodoSinglePageComponent implements OnInit, OnDestroy {
  org = '';
  user = '';
  clientId = '';
  companyId = '';
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  dateFormat: string;
  serviceDateformat: string;
  currentTodoId: string;
  currentPost: any;
  showPost: boolean;
  noResultsFound: boolean = false;
  currentTodo: any;
  isStatusDone: boolean;
  isCustomer = false;
  priorities: Array<any> = [{key: 'High', value: 'High'}, {key: 'Medium', value: 'Medium'}, {
    key: 'Low',
    value: 'Low'
  }];
  channelId = '';
  channelType = '';
  uploader: FileUploader;
  attachments: Array<any> = [];
  billUploadResp: any;
  document: any;
  storedAttachments: Array<any> = [];
  hasBaseDropZoneOver = false;
  todoDescriptionEditorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent', 'lineHeight'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Write your description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events: {},
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
  };
  togglePostTemplate = false;
  channelName = '';

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private titleService: PageTitleService,
    private stateService: StateService,
    private dateFormater: DateFormater,
    private changeDetectorRef: ChangeDetectorRef,
    private switchBoard: SwitchBoard,
    private toastService: ToastService,
    private _route: ActivatedRoute,
    private _toastService: ToastService,
    private todoService: TpFirmTodoService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private tasksService: TasksService) {
  }

  ngOnInit(): void {
    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Todo',
      id: 'TODO'
    });
    this._route.params.pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.currentTodoId = params.id;
        if (params.channelId) {
          this.channelId = params.channelId;
          this.channelType = params.channelType;
          this.channelName = params.channelName ? params.channelName : '';

        }
        this._init();
      });
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser('delegatedFrom').id;
    this.dateFormat = this.dateFormater.getFormat();
    this.isCustomer = Session.getUser('delegatedFrom').isCustomer;
    this.serviceDateformat = this.dateFormater.getServiceDateformat();
    const title = this.channelName ? `Todo's / ${this.channelName}` : `Todo's`;
    this.titleService.setPageTitle(title);
    this.getTodo();
    this.switchBoard.onToggleFeedback.next({
      display: true,
      pageName: 'Todo single page'
    });

    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$))
      .subscribe(title => {
        this.gotoDefaultPage();
      });

    this.setFileUploader();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key === 'wall-tasks') {
      this._router.navigate([prevState.url]);
    } else if (prevState && prevState.key === 'firm-todos') {
      this._router.navigate([prevState.url]);
    } else if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  getTodo() {
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    const withPost = true;
    this.todoService.getTodoTableData(this.user, this.org, this.currentTodoId, withPost)
      .subscribe(response => {
        
        if (response?.toDosList && response.toDosList.length == 0) {
          this.noResultsFound = true;
        }
        this.currentTodo = response?.toDosList[0];
        this.attachments = response?.toDosList[0]?.documents;
        this.isStatusDone = this.currentTodo?.status.toLowerCase() === 'done' ? true : false;
        if (response.post) {
          this.createdPost(response.post);
        } else {
          this.showPost = true;
        }
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        const message = error.message || `Failed To Get ToDo's`;
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  moveNextStatus(type?) {
    if (type) {
      this.currentTodo.checked = false;
    } else {
      this.currentTodo.checked = true;
    }
    if (this.attachments.length > 0) {
      this.currentTodo.documents = this.attachments;
      _.forEach(this.currentTodo.documents, function(data) {
        delete data.temporaryURL;
      });
    }

    if(type == 'save') {
      this.updateTodoData();
    } else {
      let obj = {};
      if (type == 'date') {
        this.currentTodo.dueDate = this.currentTodo.dueDate ? this.dateFormater.formatDate(this.currentTodo.dueDate, this.dateFormat, this.serviceDateformat) : '';
        obj['id'] = this.currentTodo.id;
        obj['action'] = 'singleUpdate';
        obj['actedOn'] = 'dueDate';
        obj['value'] = this.currentTodo.dueDate;
        obj['ids'] = [];
      } else if (type == 'priority') {
        obj['id'] = this.currentTodo.id;
        obj['action'] = 'singleUpdate';
        obj['actedOn'] = 'priority';
        obj['value'] = this.currentTodo.priority;
        obj['ids'] = [];
      } else if (type == 'status') {
        this.currentTodo.status = (this.currentTodo.status  && this.currentTodo.status.toLowerCase() == 'assigned') ? 'Done' : 'Assigned';
        obj['id'] = this.currentTodo.id;
        obj['action'] = 'singleUpdate';
        obj['actedOn'] = 'status';
        obj['value'] = this.currentTodo.status;
        obj['ids'] = [];
      }

      this.todoService.updateFirmTodoStatus(this.org, this.user, obj)
        .subscribe(response => {
          if(type == 'status') {
            this.isStatusDone = this.currentTodo.status.toLowerCase() === 'done' ? true : false;
            if (this.isStatusDone) {
              this.toastService.pop(TOAST_TYPE.success, 'Status Marked As Done');
            } else {
              this.toastService.pop(TOAST_TYPE.success, 'Status Moved To Assigned');
            }
          } else {
            this.toastService.pop(TOAST_TYPE.success, 'Updated Successfully');
          }
        }, error => {
          const message = error.message || 'Failed To preform action';
          this.toastService.pop(TOAST_TYPE.error, message);
          this.loadingService.triggerLoadingEvent(false);
        });

    }
  }

  updateTodoData() {
    this.currentTodo.dueDate = this.currentTodo.dueDate ? this.dateFormater.formatDate(this.currentTodo.dueDate, this.dateFormat, this.serviceDateformat) : '';
    this.todoService.updateTodoData(this.org, this.user, this.currentTodo.clientId, this.currentTodo)
      .subscribe(response => {
        this.currentTodo = response;
        this.toastService.pop(TOAST_TYPE.success, 'Todo Updated Successfully');
        this.loadingService.triggerLoadingEvent(false);
      }, error => {

        const message = error.message || 'Failed To preform action';
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  createdPost(post) {
    this.currentTodo.postId = post.id;
    this.currentPost = post;
    this.showPost = true;
  }

  setDueDate(date) {
    this.currentTodo.dueDate = date;
    this.moveNextStatus('date');
  }

  setPriority($event) {
    this.currentTodo.priority = $event.key;
    this.moveNextStatus('priority');
  }

  removeUploadItem(item) {
    item.remove();
    this.deleteDocument();
  }

  startUpload($event) {
    const base = this;
    setTimeout(() => {
      base.uploader.uploadAll();
    }, 1000);
  }

  deleteDocument() {
    // Invoke delete document service
  }

  downloadDocument(id) {
    this.taxStrategyServices.downloadDocument(this.user, this.org, id)
      .subscribe(response => {
        window.open(response.temporaryURL);
      }, error => {
      });
  }

  removeAttachment(attachment) {
    const base = this;
        this.loadingService.triggerLoadingEvent(true);
        this.taxStrategyServices.removeDocument(this.user, this.org, attachment.id).subscribe(attachments => {
            _.remove(this.attachments, {id: attachment.id});
            this.loadingService.triggerLoadingEvent(false);
            this._toastService.pop(TOAST_TYPE.success, 'Attachment Deleted Successfully');
        }, error => {
            if (error) {
                if (error && JSON.parse(error)) {
                    this._toastService.pop(TOAST_TYPE.error, JSON.parse(error).message);
                } else {
                    this._toastService.pop(TOAST_TYPE.error, 'Failed To Delete Attachment');
                }
                this.loadingService.triggerLoadingEvent(false);
            }
        });
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(Session.getOrg(), Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.currentTodoId;
      payload.sourceType = 'TODO_ATTACHMENT';
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploader.progress = 100;
        this.billUploadResp = response;
        this.uploader.queue.forEach(function(_item) {
          if (item._file.name === _item._file.name) {
            _item.remove();
          }
        });
        this.document = JSON.parse(response);
        this.compileLink();
      }
    };
  }

  compileLink() {
    const base = this;
    if (this.document && this.document.temporaryURL) {
      const data = {
        id: this.document.id,
        name: this.document.name,
        temporaryURL: this.document.temporaryURL
      };
      base.attachments.push(data);
    }
  }

  setAttachments(attachmnets) {
    const base = this;
    if (this.storedAttachments.length > 0) {
      _.forEach(this.storedAttachments, function(value) {
        const attachment = _.find(attachmnets, function(o) {
          return o.id == value.id;
        });
        if (attachment) {
          base.attachments.push(attachment);
        }
      });
    }
  }

  fileOverBase(e: any) {
    this.hasBaseDropZoneOver = e;
    this.uploader.queue.forEach(function(item) {
      item.upload();
    });
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  openPostTemplatesDropdown() {
    setTimeout(() => {
      this.togglePostTemplate = true;
      this.invokeChangeDetection();
    });
  }

  closeHandleContainer(toggleType) {
    if (toggleType === 'post-template') {
      this.togglePostTemplate = false;
    }
    this.invokeChangeDetection();
  }

  addTemplateToPost(template) {
    this.currentTodo.description += ` ${template.content}`;
  }

  deletePost($event) {
    this.currentTodo = {};
    this.invokeChangeDetection();
  }

}
